var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.footer},[_c('div',{class:_vm.$style.footerInner},[_c('a',{class:_vm.$style.logo,attrs:{"href":"#","target":"_blank","rel":"noopener noreferrer"}},[_vm._v(" Origami Group - 2024 ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }